import { IncidentTableData } from "../types";

export const createRiskIncidentRows = (
  details: Array<IncidentTableData>,
): Array<IncidentTableData> => {
  return [...details].sort((firstRow, secondRow) => {
    if (secondRow.scannedAt !== firstRow.scannedAt) {
      return secondRow.scannedAt - firstRow.scannedAt;
    }

    return firstRow.type.localeCompare(secondRow.type);
  });
};
